import { gql } from "@apollo/client";

export default gql`
  query getAllAiKnowledgeSources($data: GetAiKnowledgeSourceInput!){
    getAllAiKnowledgeSources(data: $data){
        success
        data{
            docs{
                _id
                customer
                aiProfile
                title
                chunkNumber
                status
                sourceType
                source
                createdAt
                updatedAt
                question
                answer
                isSinglePage
                createdBy
                failedReason
                channels
            }
            totalDocs
            hasPrevPage
            hasNextPage
        }
        code
        message
    }
}
`
